export const generateWineDescription = (
  vintage: number | null,
  producer: string,
  wineName: string,
  grapeVariety: string | null,
  region2: string | null,
  author: string | null = null
) => {
  let description = `${producer} ${wineName}`;
  if (vintage) {
    description += ` ${vintage}`;
  }
  if (grapeVariety) {
    description += ` is a ${grapeVariety} wine`;
  }
  else {
    description += " is a wine";
  }
  
  if (region2) {
    description += ` from ${region2}`;
  }

  if (author) {
    
    description += `. Read reviews, ratings, and tasting notes from ${author} for this wine on Vinous.`;  
  } else {
    description += `. Read reviews, ratings, and tasting notes for this wine on Vinous.`;
  }

  return description;
};
